module.exports = __webpack_public_path__ + "resource/static/img/q@1.5x.fd536ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/img1/q@1.5x.png
// module id = tPjF
// module chunks = 1